import * as mutation from "./mutation-types";
import * as action from "./action-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as levyEstimatorMutation from "@/store/levy-estimator/mutation-types";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import { deepCopyAxiosException } from "@/store/helpers";
import axios from "axios";

export const actions = {
  async [action.LIST]({ commit, state }) {
    commit(mutation.LIST_STARTED);
    try {
      const endpoint = `/api/levy-collections/${state.listing.levyCollectionId}/estimator-templates`;
      const url = tableHelper.constructUrl(endpoint, state.listing.paging);
      const { headers, data } = await axios.get(url);
      commit(mutation.LIST_SET_PAGING, tableHelper.getPagingFromHeaders(headers));
      commit(mutation.LIST_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LIST_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EDIT_GET]({ commit }, { levyCollectionId, type }) {
    commit(mutation.EDIT_GET_STARTED, { levyCollectionId, type });
    try {
      const url = `/api/levy-collections/${levyCollectionId}/estimator-templates/${type}`;
      const { data } = await axios.get(url);
      commit(mutation.EDIT_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.EDIT_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EDIT_SAVE]({ commit, state }) {
    commit(mutation.EDIT_SAVE_STARTED);
    try {
      const url = `/api/levy-collections/${state.edit.levyCollectionId}/estimator-templates/${state.edit.type}`;
      const { data } = await axios.put(url, state.edit.data);
      commit(mutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(levyEstimatorMutation.STATE_UNLOAD);
      commit(mutation.EDIT_SAVE_SUCCEEDED, data);
      commit(SHOW_NOTIFICATION, "Estimator template updated.");
      return true;
    } catch (e) {
      commit(mutation.EDIT_SAVE_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EXPORT_SPREADSHEET]({ commit, state }) {
    commit(mutation.EXPORT_SPREADSHEET_STARTED);
    try {
      commit(SHOW_NOTIFICATION, "Your export will commence shortly.");
      const url = `/api/exports/levy-collections/${state.listing.levyCollectionId}/estimator-templates`;
      tableHelper.downloadExportedSpreadsheet(url);
      commit(mutation.EXPORT_SPREADSHEET_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_SPREADSHEET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.EXPORT_JSON]({ commit, state }) {
    commit(mutation.EXPORT_JSON_STARTED);
    try {
      commit(SHOW_NOTIFICATION, "Your export will commence shortly.");
      const url = `/api/exports/levy-collections/${state.listing.levyCollectionId}/estimator-templates?asJson=true`;
      tableHelper.downloadExportedSpreadsheet(url);
      commit(mutation.EXPORT_JSON_SUCCEEDED);
      return true;
    } catch (e) {
      commit(mutation.EXPORT_JSON_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
